// extracted by mini-css-extract-plugin
export var item = "d2_sN";
export var text = "d2_gP";